import EventBusyIcon from '@material-ui/icons/EventBusy';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import EventNoteIcon from '@material-ui/icons/EventNote';
// import StopIcon from '@material-ui/icons/Stop';

export default [
  {
    id: 'leave',
    label: '請假',
    icon: EventBusyIcon,
    color: '#e57373',
  },
  {
    id: 'medical',
    label: '醫療',
    icon: LocalHospitalIcon,
    color: '#f06292',
  },
  {
    id: 'reminder',
    label: '提醒',
    icon: EventNoteIcon,
    color: '#64b5f6',
  },
  // {
  //   id: 'serviceStop',
  //   label: '停止服務',
  //   icon: StopIcon,
  //   color: '#ba68c8',
  // },
];
